/**
 * Shared MUSKLE Productgids return-context bar.
 * Shows only when mpg_from=article|products with safe internal restore params.
 * Never follows external redirect URLs.
 */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function isSafeHandle(value) {
    return typeof value === "string" && /^[a-z0-9-]{2,120}$/.test(value);
  }

  function isSafePage(value) {
    var n = parseInt(value || "", 10);
    return n >= 1 && n <= 999 ? String(n) : "";
  }

  function isSafeCat(value) {
    return typeof value === "string" && /^[a-z0-9_-]{0,80}$/i.test(value) ? value : "";
  }

  function isSafeSearch(value) {
    if (typeof value !== "string") return "";
    var t = value.trim().slice(0, 80);
    return /^[\w\s\-.'+]{0,80}$/i.test(t) ? t : "";
  }

  function overviewFrom(el) {
    return el.getAttribute("data-mpg-back-overview") || "/pages/productgids-overzicht";
  }

  ready(function () {
    var boxes = document.querySelectorAll("[data-mpg-return-context]");
    if (!boxes.length) return;

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }

    var from = (params.get("mpg_from") || "").toLowerCase();
    var article = (params.get("mpg_article") || "").toLowerCase();
    var product = (params.get("mpg_product") || "").toLowerCase();
    var page = isSafePage(params.get("mpg_page"));
    var cat = isSafeCat(params.get("mpg_cat") || "");
    var search = isSafeSearch(params.get("mpg_search") || "");
    var preview = params.get("preview_theme_id") || "";
    if (preview && !/^\d{6,20}$/.test(preview)) preview = "";

    var show = false;
    var labelKey = "";
    var hrefBuilder = null;

    if (from === "article" && isSafeHandle(article)) {
      show = true;
      labelKey = "article";
      hrefBuilder = function (overview) {
        var u =
          overview +
          "?mpg_mode=artikelen&mpg_article=" +
          encodeURIComponent(article) +
          "&mpg_open=1";
        if (preview) u += "&preview_theme_id=" + encodeURIComponent(preview);
        return u;
      };
    } else if (from === "products") {
      show = true;
      labelKey = "products";
      hrefBuilder = function (overview) {
        var u = overview + "?mpg_mode=producten";
        if (isSafeHandle(product)) u += "&mpg_product=" + encodeURIComponent(product);
        if (page) u += "&mpg_page=" + encodeURIComponent(page);
        if (cat) u += "&mpg_cat=" + encodeURIComponent(cat);
        if (search) u += "&mpg_search=" + encodeURIComponent(search);
        if (preview) u += "&preview_theme_id=" + encodeURIComponent(preview);
        return u;
      };
    }

    Array.prototype.forEach.call(boxes, function (el) {
      if (!show || !hrefBuilder) {
        el.hidden = true;
        return;
      }
      var overview = overviewFrom(el);
      var label =
        labelKey === "products"
          ? el.getAttribute("data-mpg-back-label-products") || "← Terug naar Producten"
          : el.getAttribute("data-mpg-back-label-article") || "← Terug naar artikel";
      var href = hrefBuilder(overview);
      var link = el.querySelector("[data-mpg-return-link]");
      if (link) {
        link.setAttribute("href", href);
        link.textContent = label;
      }
      el.hidden = false;
    });
  });
})();
